import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToolbarModule } from '../public/toolbar/toolbar.module';
import { TermsAndConditionsComponent } from './terms-and-conditions.component';

@NgModule({
  declarations: [TermsAndConditionsComponent],
  exports: [TermsAndConditionsComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: TermsAndConditionsComponent
      }
    ]),
    ToolbarModule
  ]
})
export class TermsAndConditionsModule {}
